module.exports = __webpack_public_path__ + "img/alto_bilaterale_dx.ab6f5536.png";